import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { getOfertas } from '../grapql/ofertas';

@Injectable({
  providedIn: 'root'
})
export class OffersService {
  private url = environment.api;

  constructor(private http: HttpClient) { }

  getOffers(): Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getOfertas()}).pipe(
      map((res: any) => res.data.ofertas)
    );
  }
}
